import { CouponsErrorType, GenericErrorType } from '../../../../types/errors';
import { FormContext } from '../../../../utils/context/contextFactory';
import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { FormState } from '../../../../utils/state/initialStateFactory';
import { CalculatePaymentDetails } from '../calculatePaymentDetails/calculatePaymentDetails';
import { ErrorHandlers } from '../errorHandlers/errorHandlers';

export type SetCoupon = (couponCode: string) => void;

export function createSetCouponAction(
  actionFactoryParams: ActionFactoryParams<FormState, FormContext>,
  errorHandlers: ErrorHandlers,
  calculatePaymentDetails: CalculatePaymentDetails,
): SetCoupon {
  return async (couponCode: string) => {
    errorHandlers.clearErrorByTypes([CouponsErrorType, GenericErrorType]);
    if (couponCode) {
      calculatePaymentDetails(couponCode);
    }
  };
}
